import createIcon from '../../createIcon';

/**
 * @component @name LocalPolice
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMUwzIDVWMTFDMyAxNi41NSA2Ljg0IDIxLjc0IDEyIDIzQzE3LjE2IDIxLjc0IDIxIDE2LjU1IDIxIDExVjVMMTIgMVpNMTQuNSAxMi41OUwxNS40IDE2LjQ3TDEyIDE0LjQyTDguNiAxNi40N0w5LjUgMTIuNkw2LjUgMTAuMDFMMTAuNDYgOS42N0wxMiA2LjAyTDEzLjU0IDkuNjZMMTcuNSAxMEwxNC41IDEyLjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalPolice = createIcon('LocalPolice', [
  [
    'path',
    {
      d: 'M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM14.5 12.59L15.4 16.47L12 14.42L8.6 16.47L9.5 12.6L6.5 10.01L10.46 9.67L12 6.02L13.54 9.66L17.5 10L14.5 12.59Z',
      key: '8y3noz',
    },
  ],
]);

export default LocalPolice;
